export default function PersonProhibitedIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='6.25 5.25 13.5 13.5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M7 14.8001C7.00041 14.2049 7.14829 13.6192 7.43043 13.0951C7.71257 12.5711 8.12017 12.1252 8.6168 11.7972C9.11342 11.4692 9.68357 11.2694 10.2763 11.2157C10.869 11.1619 11.4658 11.2559 12.0133 11.4891'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.39997 8.2C8.39997 8.48891 8.45688 8.77499 8.56744 9.0419C8.678 9.30882 8.84005 9.55135 9.04434 9.75564C9.24863 9.95992 9.49115 10.122 9.75807 10.2325C10.025 10.3431 10.3111 10.4 10.6 10.4C10.8889 10.4 11.175 10.3431 11.4419 10.2325C11.7088 10.122 11.9513 9.95992 12.1556 9.75564C12.3599 9.55135 12.5219 9.30882 12.6325 9.0419C12.7431 8.77499 12.8 8.48891 12.8 8.2C12.8 7.61652 12.5682 7.05695 12.1556 6.64437C11.743 6.23179 11.1834 6 10.6 6C10.0165 6 9.45692 6.23179 9.04434 6.64437C8.63176 7.05695 8.39997 7.61652 8.39997 8.2Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.6 14.7989C12.6 15.6476 12.9371 16.4615 13.5372 17.0616C14.1374 17.6617 14.9513 17.9989 15.8 17.9989C16.6487 17.9989 17.4626 17.6617 18.0627 17.0616C18.6629 16.4615 19 15.6476 19 14.7989C19 13.9502 18.6629 13.1363 18.0627 12.5361C17.4626 11.936 16.6487 11.5989 15.8 11.5989C14.9513 11.5989 14.1374 11.936 13.5372 12.5361C12.9371 13.1363 12.6 13.9502 12.6 14.7989Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M13.5376 17.0609L18.0624 12.5361' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
